module.exports = __webpack_public_path__ + "assets/img/27_1241_big.20c6229f.jpg";